import { render } from "./ParaCard.vue?vue&type=template&id=27e23a52&scoped=true"
import script from "./ParaCard.vue?vue&type=script&lang=js"
export * from "./ParaCard.vue?vue&type=script&lang=js"

import "./ParaCard.vue?vue&type=style&index=0&id=27e23a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e23a52"]])

export default __exports__